export default [
  {
    code: 'id',
    name: 'id',
    type: 'id',
  },
  {
    code: 'lastName',
    name: 'last_name',
    type: 'input',
  },
  {
    code: 'firstName',
    name: 'first_name',
    type: 'input',
  },
  {
    code: 'middleName',
    name: 'middle_name',
    type: 'input',
  },
  {
    code: 'sex',
    name: 'sex',
    type: 'select',
    dictionary: 'sex',
    itemValue: 'code',
    itemText: 'name',
  },
  {
    code: 'description',
    name: 'description',
    type: 'input',
  },
  {
    code: 'status',
    name: 'status',
    type: 'select',
    dictionary: 'contactstatus',
    itemValue: 'code',
    itemText: 'name',
  },
]
